import gql from 'graphql-tag';

export default gql`
mutation AddApp(
        $lang: String!,
        $currency: String!,
        $origin: String
        ) {
    createApps(input:{
        lang: $lang,
        currency: $currency,
        origin: $origin
    }) {
        __typename
        uuid
    }
}
`;
